import { render, staticRenderFns } from "./MemberEn.vue?vue&type=template&id=487a177e&scoped=true&"
import script from "./MemberEn.vue?vue&type=script&lang=js&"
export * from "./MemberEn.vue?vue&type=script&lang=js&"
import style0 from "./MemberEn.vue?vue&type=style&index=0&id=487a177e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a177e",
  null
  
)

export default component.exports